import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'

import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'
import { SCHEDULED } from 'settings/_scheduleStatusSettings'

const PARTICULAR_PLAN_CODE = 'PLN01000'
const PATIENT_SCHEDULE_LIST_QUERY_KEY = 'PATIENT_SCHEDULE_LIST'

async function fetchPatientScheduleList(patientUsername: string) {
  const params = {
    username: patientUsername,
    status_code: SCHEDULED
  }
  
  const { data } = await axios.get(apiEndpoints.SCHEDULES, { params })

  return data
}

const removeParticularScheduleFromList = (scheduleList) => {
  return scheduleList?.filter(schedule => schedule?.order_item?.order.plan_code !== PARTICULAR_PLAN_CODE)
}

export const usePatientScheduleList = ({ patientUsername, removeParticularSchedules }) => {
  const [patientScheduleList, setPatientScheduleList] = useState([])
  
  const { isFetching, isSuccess } = useQuery({
    queryKey: [PATIENT_SCHEDULE_LIST_QUERY_KEY, patientUsername],
    queryFn: () => fetchPatientScheduleList(patientUsername),
    onSuccess: (data) => {
      if (!removeParticularSchedules) {
        setPatientScheduleList(data?.schedules)
        return
      }

      const filteredScheduleList = removeParticularScheduleFromList(data?.schedules)
      setPatientScheduleList(filteredScheduleList)
    },
    onError: () => {
      setPatientScheduleList([])
    },
    enabled: !!patientUsername,
    retry: 3,
    refetchInterval: false,
    refetchOnWindowFocus: false,
    cacheTime: 0,
  })
  
  return {
    isFetching,
    isSuccess,
    patientScheduleList,
  }
}